import {
  IDesktopDocument,
  IExtformDocument,
  ILogonDocument,
} from 'app/services/api5-service/api.interface';

import { DynamicFormContext } from 'common/dynamic-form/model';
import { DocHelper } from 'utils/dochelper';

/**
 * Get some additional information for dynamic form from desktop or extform doc
 *
 * @param doc - desktop or extform doc
 */
export function getDynamicFormContext(
  doc?: IDesktopDocument | IExtformDocument | ILogonDocument,
): DynamicFormContext {
  return {
    msgError: DocHelper.getMessage('msg_error', doc),
    passwordGenLength: Number((doc as IDesktopDocument)?.pwgenlen?.$) || 14,
    passwordGenChars: (doc as IDesktopDocument)?.pwgencharacters?.$ || '',
    passwordStrength: (doc as IDesktopDocument)?.pwstrength?.$ || '0',
    collapseTooltipMsg: DocHelper.getMessage('hint_page_collapse', doc),
    expandTooltipMsg: DocHelper.getMessage('hint_page_expand', doc),
    validationDuplicateMsg: DocHelper.getMessage('msg_duplicate', doc),
    validationRequiredMsg: DocHelper.getMessage('msg_empty', doc),
    validationFileMaxSizeMsg: DocHelper.getMessage('msg_filemaxsize', doc),
    notFoundMsg: DocHelper.getMessage('msg_notfound', doc),
    fileUploadMsg: DocHelper.getMessage('msg_form_sending', doc),
    okMsg: DocHelper.getMessage('msg_ok', doc),
    cancelMsg: DocHelper.getMessage('msg_cancel', doc),
    forceHint: Boolean(doc?.$forcehint) || false,
  };
}
